import axios from "./axios";
import { entityGenderEnum, entityRoleEnum, entityVerificationStatusEnum } from "../enums/entity.enum";

export const fetchCountries = async () => {
  try {
    const response = await axios.get(`/countries`);
    return response.data.data.items;
  } catch (err) {
    throw new Error(err + " Failed to fetch network countries");
  }
};

export const fetchEntityFollowers = async (
  entityId: number,
  limit: number,
  offset: number,
  location?: string | null | "",
  country?: string | null | "",
  gender?: entityGenderEnum | null | "",
  verificationStatus?: entityVerificationStatusEnum | null | "",
  entityRole?: entityRoleEnum | null | "",
  nationalityId?: number | null | "",
  filters?: Record<string, any> // Optional filters parameter
) => {
  try {
    // Construct the base query string
    let queryParams = `?limit=${limit}&offset=${offset * 12}`;

    // Append optional parameters to the query string
    if (location) queryParams += `&countryId=${location}`;
    if (country) queryParams += `&nationalityId=${country}`;
    if (gender) queryParams += `&gender=${gender}`;
    if (verificationStatus) queryParams += `&verificationStatus=${verificationStatus}`;
    if (entityRole) queryParams += `&role=${entityRole.toUpperCase()}`;
    if (nationalityId) queryParams += `&nationalityId=${nationalityId}`;

    // Append the filters to the query string
    if (filters) {
      for (const [key, value] of Object.entries(filters)) {
        let encodedValue;
        if (Array.isArray(value)) {
          // Convert array to a comma-separated string
          encodedValue = value.filter((v) => v !== null && v !== "").join("-");
        } else {
          encodedValue = value;
        }

        if (encodedValue) {
          queryParams += `&${encodeURIComponent(key)}=${encodeURIComponent(encodedValue)}`;
        }
      }
    }

    // Make the GET request with the constructed query string
    const response = await axios.get(`/football-entities/${entityId}/followers${queryParams}`);

    return response.data.data;
  } catch (err) {
    throw new Error(err + " Failed to fetch network followers");
  }
};

export const fetchEntityFollowing = async (
  entityId: number,
  limit: number,
  offset: number,
  location?: string | "" | null,
  country?: string | "" | null,
  gender?: entityGenderEnum | "" | null,
  verificationStatus?: entityVerificationStatusEnum | "" | null,
  entityRole?: entityRoleEnum | null | "",
  //   countryId?: number,
  nationalityId?: number | null,
  filters?: Record<string, any> // Optional filters parameter
) => {
  try {
    // Construct the base query string
    let queryParams = `?limit=${limit}&offset=${offset * 12}`;

    // Append optional parameters to the query string
    if (location) queryParams += `&countryId=${location}`;
    if (country) queryParams += `&nationalityId=${country}`;
    if (gender) queryParams += `&gender=${gender}`;
    if (verificationStatus) queryParams += `&verificationStatus=${verificationStatus}`;
    if (entityRole) queryParams += `&role=${entityRole.toUpperCase()}`;
    // if (countryId) queryParams += `&countryId=${countryId}`;
    if (nationalityId) queryParams += `&nationalityId=${nationalityId}`;

    // Append the filters to the query string
    if (filters) {
      for (const [key, value] of Object.entries(filters)) {
        let encodedValue;
        if (Array.isArray(value)) {
          // Convert array to a comma-separated string
          encodedValue = value.filter((v) => v !== null && v !== "").join("-");
        } else {
          encodedValue = value;
        }
        if (encodedValue) {
          queryParams += `&${encodeURIComponent(key)}=${encodeURIComponent(encodedValue)}`;
        }
      }
    }
    // Make the GET request with the constructed query string
    const response = await axios.get(`/football-entities/${entityId}/following${queryParams}`);

    return response.data.data;
  } catch (err) {
    throw new Error(err + " Failed to fetch network followers");
  }
};

export const fetchUserFollowers = async (
  userId: number,
  limit: number,
  offset: number,
  location?: string | null | "",
  country?: string | null | "",
  gender?: entityGenderEnum | null | "",
  verificationStatus?: entityVerificationStatusEnum | null | "",
  entityRole?: entityRoleEnum | null | "",
  nationalityId?: number | null | "",
  filters?: Record<string, any>
) => {
  try {
    // Construct the base query string
    let queryParams = `?limit=${limit}&offset=${offset * 12}`;

    // Append optional parameters to the query string
    if (location) queryParams += `&countryId=${location}`;
    if (country) queryParams += `&nationalityId=${country}`;
    if (gender) queryParams += `&gender=${gender}`;
    if (verificationStatus) queryParams += `&verificationStatus=${verificationStatus}`;
    if (entityRole) queryParams += `&role=${entityRole.toUpperCase()}`;
    if (nationalityId) queryParams += `&nationalityId=${nationalityId}`;

    // Append the filters to the query string
    if (filters) {
      for (const [key, value] of Object.entries(filters)) {
        let encodedValue;
        if (Array.isArray(value)) {
          // Convert array to a comma-separated string
          encodedValue = value.filter((v) => v !== null && v !== "").join("-");
        } else {
          encodedValue = value;
        }

        if (encodedValue) {
          queryParams += `&${encodeURIComponent(key)}=${encodeURIComponent(encodedValue)}`;
        }
      }
    }

    // Make the GET request with the constructed query string
    const response = await axios.get(`/users/${userId}/followers${queryParams}`);
    return response.data;
  } catch (err) {
    throw new Error(err + " Failed to fetch user followers");
  }
};

export const fetchUserFollowing = async (
  userId: number,
  limit: number,
  offset: number,
  location?: string | "" | null,
  country?: string | "" | null,
  gender?: entityGenderEnum | "" | null,
  verificationStatus?: entityVerificationStatusEnum | "" | null,
  entityRole?: entityRoleEnum | null | "",
  //   countryId?: number,
  nationalityId?: number | null,
  filters?: Record<string, any> // Optional filters parameter
) => {
  try {
    // Construct the base query string
    let queryParams = `?limit=${limit}&offset=${offset * 12}`;

    // Append optional parameters to the query string
    if (location) queryParams += `&countryId=${location}`;
    if (country) queryParams += `&nationalityId=${country}`;
    if (gender) queryParams += `&gender=${gender}`;
    if (verificationStatus) queryParams += `&verificationStatus=${verificationStatus}`;
    if (entityRole) queryParams += `&role=${entityRole.toUpperCase()}`;
    // if (countryId) queryParams += `&countryId=${countryId}`;
    if (nationalityId) queryParams += `&nationalityId=${nationalityId}`;

    // Append the filters to the query string
    if (filters) {
      for (const [key, value] of Object.entries(filters)) {
        let encodedValue;
        if (Array.isArray(value)) {
          // Convert array to a comma-separated string
          encodedValue = value.filter((v) => v !== null && v !== "").join("-");
        } else {
          encodedValue = value;
        }
        if (encodedValue) {
          queryParams += `&${encodeURIComponent(key)}=${encodeURIComponent(encodedValue)}`;
        }
      }
    }
    // Make the GET request with the constructed query string
    const response = await axios.get(`/users/${userId}/following${queryParams}`);

    return response.data;
  } catch (err) {
    throw new Error(err + " Failed to fetch network followers");
  }
};

export const getAdvancedSearchLists = async (listName: string) => {
  try {
    const response = await axios.get(`lists/${listName}`);
    return response.data.items;
  } catch (err) {
    throw new Error(err + " Failed to fetch list");
  }
};

export const getSkillsLists = async (role: string) => {
  try {
    const response = await axios.get(`skills?role=${role}`);
    return response.data.data.items;
  } catch (err) {
    throw new Error(err + " Failed to fetch skills list");
  }
};

export const getFriends = async (
  userId: number,
  limit: number = 10,
  offset: number = 0,
  location?: string | "" | null,
  country?: string | "" | null,
  gender?: entityGenderEnum | "" | null,
  verificationStatus?: entityVerificationStatusEnum | "" | null,
  entityRole?: entityRoleEnum | null | "",
  //   countryId?: number,
  nationalityId?: number | null,
  filters?: Record<string, any> // Optional filters parameter
) => {
  let queryParams = `?limit=${limit}&offset=${offset * 12}`;

  // Append optional parameters to the query string
  if (location) queryParams += `&countryId=${location}`;
  if (country) queryParams += `&nationalityId=${country}`;
  if (gender) queryParams += `&gender=${gender}`;
  if (verificationStatus) queryParams += `&verificationStatus=${verificationStatus}`;
  if (entityRole) queryParams += `&role=${entityRole.toUpperCase()}`;
  // if (countryId) queryParams += `&countryId=${countryId}`;
  if (nationalityId) queryParams += `&nationalityId=${nationalityId}`;

  // Append the filters to the query string
  if (filters) {
    for (const [key, value] of Object.entries(filters)) {
      let encodedValue;
      if (Array.isArray(value)) {
        // Convert array to a comma-separated string
        encodedValue = value.filter((v) => v !== null && v !== "").join("-");
      } else {
        encodedValue = value;
      }
      if (encodedValue) {
        queryParams += `&${encodeURIComponent(key)}=${encodeURIComponent(encodedValue)}`;
      }
    }
  }
  try {
    const response = await axios.get(`users/${userId}/network/v1${queryParams}`);
    return response.data.data;
  } catch (err) {
    throw new Error(err + " Failed to fetch skills list");
  }
};

export const followUser = async (userId: number) => {
  try {
    const response = await axios.patch(`users/${userId}/follow`);
    return response.data.isFollowing;
  } catch (err) {
    throw new Error(err + " Failed to follow user");
  }
};

export const unFollowUser = async (userId: number) => {
  try {
    const response = await axios.delete(`users/${userId}/follow`);
    return response.data.isFollowing;
  } catch (err) {
    throw new Error(err + " Failed to follow user");
  }
};

export const followEntity = async (entityId: number | null) => {
  if (!entityId) return;
  try {
    const response = await axios.put(`football-entities/${entityId}/follow`);
    return response.data.isFollowing;
  } catch (err) {
    throw new Error(err + " Failed to follow user");
  }
};

export const unFollowEntity = async (entityId: number) => {
  try {
    const response = await axios.delete(`football-entities/${entityId}/follow`);
    return response.data.isFollowing;
  } catch (err) {
    throw new Error(err + " Failed to follow user");
  }
};

export const searchUsers = async (
  limit: number,
  offset: number,
  searchValue?: string,
  countryId?: string | "",
  nationalityId?: string | "",
  gender?: entityGenderEnum | "",
  verificationStatus?: "VERIFIED" | "",
  role?: string | "",
  trending?: boolean,
  isFollowing?: boolean
) => {
  try {
    let queryParams = `?limit=${limit}&offset=${offset * limit}`;
    if (searchValue) queryParams += `&name=${searchValue}`;
    if (countryId) queryParams += `&countryId=${countryId}`;
    if (nationalityId) queryParams += `&nationalityId=${nationalityId}`;
    if (gender) queryParams += `&gender=${gender}`;
    if (verificationStatus) queryParams += `&verificationStatus=${verificationStatus}`;
    if (role) queryParams += `&role=${role.toUpperCase()}`;
    if (trending) queryParams += `&trendingStatus=TRENDING_THIS_MONTH`;
    if (isFollowing) queryParams += `&isFollowing=${isFollowing}`;

    const response = await axios.get(`/search/v1/users${queryParams}`);
    return response.data;
  } catch (err) {
    throw new Error(err + " Failed to fetch user followers");
  }
};

export const searchGroups = async (
  limit: number,
  offset: number,
  searchValue?: string,
  countryId?: string | "",
  nationalityId?: string | "",
  gender?: entityGenderEnum | "",
  verificationStatus?: "VERIFIED" | "",
  role?: string | "",
  trending?: boolean,
  isFollowing?: boolean
) => {
  try {
    let queryParams = `?limit=${limit}&offset=${offset * limit}`;
    if (searchValue) queryParams += `&name=${searchValue}`;
    if (countryId) queryParams += `&countryId=${countryId}`;
    if (nationalityId) queryParams += `&nationalityId=${nationalityId}`;
    if (gender) queryParams += `&gender=${gender}`;
    if (verificationStatus) queryParams += `&verificationStatus=${verificationStatus}`;
    if (role) queryParams += `&role=${role.toUpperCase()}`;
    if (trending) queryParams += `&trendingStatus=TRENDING_THIS_MONTH`;
    if (isFollowing) queryParams += `&isFollowing=${isFollowing}`;

    const response = await axios.get(`/search/v1/users${queryParams}`);

    return response.data;
  } catch (err) {
    throw new Error(err + " Failed to fetch user followers");
  }
};

export const searchEntities = async (
  limit: number,
  offset: number,
  searchValue?: string,
  countryId?: string | "",
  nationalityId?: string | "",
  isManagedByEntity?: boolean,
  trending?: boolean,
  verificationStatus?: "VERIFIED" | "UNVERIFIED" | ""
) => {
  try {
    let queryParams = `?limit=${limit}&offset=${offset}`;
    if (searchValue) queryParams += `&search=${searchValue}`;
    if (countryId) queryParams += `&countryId=${countryId}`;
    if (nationalityId) queryParams += `&nationalityId=${nationalityId}`;
    if (isManagedByEntity) queryParams += `&status=approved&isManagedByEntity=true`;
    if (trending) queryParams += `&trendingStatus=TRENDING_THIS_MONTH`;
    if (verificationStatus) queryParams += `&verificationStatus=${verificationStatus}`;

    const response = await axios.get(`/search/football-entities${queryParams}`);

    return response.data;
  } catch (err) {
    throw new Error(err + " Failed to fetch user followers");
  }
};

export const getTrendingTalents = async () => {
  try {
    const response = await searchUsers(3, 0, "", "", "", "", "", "PLAYER", true);
    return response.items;
  } catch (err) {
    throw new Error(err + " Failed to get trending talents");
  }
};

export const getTrendingProfessionals = async () => {
  try {
    const response = await searchUsers(3, 0, "", "", "", "", "", "COACH,AGENT,SCOUT,OTHER", true);
    return response.items;
  } catch (err) {
    throw new Error(err + " Failed to get trending professionals");
  }
};

export const getTrendingEntities = async () => {
  try {
    const response = await searchEntities(3, 0, "", "", "", false, true);
    return response.items;
  } catch (err) {
    throw new Error(err + " Failed to get trending professionals");
  }
};
